angular.module('todo')
    .component('todoBtnOptions', {
        bindings: {
            item: '<',
            largeButton: '<',
            onDeleted: '&',
            btnXs: '<'
        },
        templateUrl: "app/todo/btn-options.html",
        controller: function ($rootScope, Todo, TodoService, FilesLibrary, FilesSimpleUploadService, Principal) {
            this.TodoService = TodoService
            this.FilesLibrary = FilesLibrary
            this.FilesSimpleUploadService = FilesSimpleUploadService

            this.fileResourceName = 'TODO'
            this.execute0nDeleted = this.onDeleted || angular.noop;

            this.$onChanges = () => {
                Principal.currentUser().then(user => {
                    this.isCreator = this.item.audit.createdBy.id === user.id && this.item.moderator == null && this.item.supervisor == null
                    this.isModerator = this.item.moderator != null && this.item.moderator.id === user.id
                    this.isSupervisor = this.item.supervisor != null && this.item.supervisor.id === user.id
                    this.canDelete = this.isCreator || this.isModerator || this.isSupervisor || Principal.hasAnyAuthority(['ROLE_ADMIN'])
                })
            }

            this.attachFile = () => FilesSimpleUploadService.open({type: this.fileResourceName, id: this.item.id}).then(() => $rootScope.$broadcast('todo.updated'));
            this.attachLibraryFile = () => FilesLibrary.openAndBind({type: this.fileResourceName, id: this.item.id}).then(() => $rootScope.$broadcast('todo.updated'));

            this.clone = () => TodoService.clone(this.item)

            this.show = () => TodoService.show(this.item.id)
            this.edit = () => TodoService.edit(this.item.id)
            this.delete = () => TodoService.remove(this.item).then(() => this.execute0nDeleted())
        }
    })
